import { z } from 'zod';
import { idInput } from './common';
import { userProfileEnum } from './auth';

export const createCargoInput = z.object({
  nome: z.string().min(2, 'Nome deve ter no minimo 2 caracteres'),
  permissoes: z.array(userProfileEnum).min(1, 'Selecione ao menos uma permissao'),
});

export const updateCargoInput = idInput.extend({
  nome: z.string().min(2).optional(),
  permissoes: z.array(userProfileEnum).optional(),
  ativo: z.boolean().optional(),
});

export const listCargosInput = z.object({
  ativo: z.boolean().optional(),
});

export type CreateCargoInput = z.infer<typeof createCargoInput>;
export type UpdateCargoInput = z.infer<typeof updateCargoInput>;
export type ListCargosInput = z.infer<typeof listCargosInput>;
